import { LOCATION_CHANGE } from 'redux-first-history';
import {
  ACCOUNTS_GET,
  ACCOUNT_FINANCIAL_ASSETS_GET,
  ACCOUNT_LIFESTYLE_COSTS_GET,
  ACCOUNT_RISK_APPETITE_PROFILES_GET,
  ACCOUNT_SIMULATE_RISK_PROFILE,
  ACCOUNT_TOTAL_WEALTH_CHART_GET,
  ACCOUNT_FINANCIAL_EXPERIENCES_GET,
  ACCOUNT_OWNERS_GET,
  ACCOUNT_INVESTMENT_AGREEMENTS_GET,
  ACCOUNT_GET,
  ACCOUNT_AML_PROFILES_GET,
  ACCOUNT_TAX_SCHEMES_GET,
  ACCOUNT_CONTRACTS_GET,
  ACCOUNT_DOCUMENTS_GET,
  ACCOUNT_AUMS_GET,
} from '../actions/types';
import { clientPaths } from '../../paths';

const getAccountId = (location) => {
  const locArray = location.pathname.toLowerCase().split('/');
  const pathArray = clientPaths.accounts.complete.split('/');

  for (let i = 0; i < pathArray.length; i += 1) {
    if (i >= locArray.length || pathArray[i] !== locArray[i]) return null;
  }

  const id = locArray[pathArray.length];
  const uuidRegex = new RegExp(/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i);
  if (uuidRegex.test(id)) return id;

  return null;
};

export const initialState = {
  accountId: null,
  items: null,
  details: {}, // [accountId]: details
  fees: {}, // [accountId]: fees
  riskAppetiteProfiles: {}, // [accountId]: riskAppetiteProfiles
  financialAssets: {}, // [accountId]: financialAssets
  lifestyleCosts: {}, // [accountId]: lifestyleCosts
  financialExperiences: {}, // [accountId]: financialExperiences,
  charts: {}, // [accountId]: { chart1: {}, chart2: {} },
  owners: {}, // [accountId]: { owners: [] }
  investmentAgreements: undefined, // investmentAgreements[]
  simulatedRiskProfiles: {}, // [accountId]: { simulatedRiskProfiles: [] }
  amlProfiles: {}, // [accountId]: { amlProfiles: [] }
  taxSchemes: {}, // [accountId]: { taxSchemes: [] }
  contracts: {}, // [accountId]: { contracts: [] }
  documents: {}, // [accountId]: { documents: [] }
  aums: {}, // [accountId]: { aums: [] }
};

export const accounts = (state = initialState, action) => {
  switch (action.type) {
    case ACCOUNTS_GET._SUCCESS: {
      state.items = action.payload.accounts || [];
      return state;
    }
    case ACCOUNT_GET._SUCCESS: {
      const { accountId, account } = action.payload;
      state.details[accountId] = account;
      return state;
    }
    case ACCOUNT_OWNERS_GET._SUCCESS: {
      const { accountId, owners } = action.payload;
      state.owners[accountId] = owners;
      return state;
    }
    case ACCOUNT_RISK_APPETITE_PROFILES_GET._SUCCESS: {
      const { accountId, riskAppetiteProfiles } = action.payload;
      state.riskAppetiteProfiles[accountId] = riskAppetiteProfiles;
      return state;
    }
    case ACCOUNT_FINANCIAL_ASSETS_GET._SUCCESS: {
      const { accountId, financialAssets } = action.payload;
      state.financialAssets[accountId] = financialAssets;
      return state;
    }
    case ACCOUNT_LIFESTYLE_COSTS_GET._SUCCESS: {
      const { accountId, lifestyleCosts } = action.payload;
      state.lifestyleCosts[accountId] = lifestyleCosts;
      return state;
    }
    case ACCOUNT_FINANCIAL_EXPERIENCES_GET._SUCCESS: {
      const { accountId, financialExperiences } = action.payload;
      state.financialExperiences[accountId] = financialExperiences;
      return state;
    }
    case ACCOUNT_TOTAL_WEALTH_CHART_GET._SUCCESS: {
      const { accountId, chart } = action.payload;
      state.charts[accountId] = { ...state.charts[accountId], totalWealth: chart };
      return state;
    }
    case ACCOUNT_INVESTMENT_AGREEMENTS_GET._SUCCESS: {
      const { investmentAgreements } = action.payload;
      state.investmentAgreements = investmentAgreements;
      return state;
    }
    case ACCOUNT_AML_PROFILES_GET._SUCCESS: {
      const { accountId, amlProfiles } = action.payload;
      state.amlProfiles[accountId] = amlProfiles;
      return state;
    }
    case ACCOUNT_TAX_SCHEMES_GET._SUCCESS: {
      const { accountId, taxSchemes } = action.payload;
      state.taxSchemes[accountId] = taxSchemes;
      return state;
    }
    case ACCOUNT_CONTRACTS_GET._SUCCESS: {
      const { accountId, contracts } = action.payload;
      state.contracts[accountId] = contracts;
      return state;
    }
    case ACCOUNT_SIMULATE_RISK_PROFILE._SUCCESS: {
      const { accountId, riskProfileCalculation } = action.payload;
      state.simulatedRiskProfiles[accountId] = riskProfileCalculation;
      return state;
    }
    case ACCOUNT_DOCUMENTS_GET._SUCCESS: {
      console.log(action.payload);
      const { accountId, documents } = action.payload;
      state.documents[accountId] = documents;
      return state;
    }
    case LOCATION_CHANGE: {
      const { location } = action.payload;
      state.accountId = getAccountId(location);
      return state;
    }
    case ACCOUNT_AUMS_GET._SUCCESS: {
      const { accountId, aums } = action.payload;
      state.aums[accountId] = aums;
      return state;
    }
    default:
      return state;
  }
};
